module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_tv_radio-18dda9937f9c8bb7d33876381bd489b1.svg";